import React from "react";
import { Instagram } from "lucide-react";
import { http } from "@/lib/api";

export default function Equipe() {
  const [teachers, setTeachers] = React.useState([]);
  React.useEffect(() => { http.get("/teachers").then(r => setTeachers(r.data)).catch(() => setTeachers([])); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
      <p className="he-overline text-neutral-500">Afrolat’Studio</p>
      <h1 className="font-heading text-5xl sm:text-6xl font-black tracking-tighter mt-3">L’équipe</h1>
      <p className="mt-4 text-neutral-600 font-body max-w-2xl">
        Une équipe, des univers, une même passion. Chaque professeur·e apporte sa signature artistique et son énergie.
      </p>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {teachers.map((t) => (
          <article key={t.id} className="border border-black/10 rounded-2xl overflow-hidden hover:border-[var(--he-red)] transition-colors">
            <div className="aspect-[4/5] bg-neutral-100 flex items-center justify-center relative overflow-hidden">
              {t.photo ? (
                <img src={t.photo} alt={t.first_name} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" />
              ) : (
                <div className="font-heading text-7xl font-black text-neutral-300">{t.first_name.charAt(0)}</div>
              )}
            </div>
            <div className="p-5">
              <h3 className="font-heading text-2xl font-bold">{t.first_name}</h3>
              <p className="text-sm text-neutral-500 mt-1">{t.disciplines.length ? t.disciplines.join(" · ") : "Discipline à préciser"}</p>
              {t.bio ? <p className="mt-3 text-sm text-neutral-600 font-body">{t.bio}</p> : null}
              {t.instagram ? (
                <a href={t.instagram} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-1 text-xs text-[var(--he-red)]">
                  <Instagram className="w-4 h-4" /> Instagram
                </a>
              ) : null}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
